// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zg-faq[data-v-4548303e]{padding:0}.zg-faq .item[data-v-4548303e]:last-child{border-bottom:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
